import { Common } from '~/models/common';
import { Image } from './image';

export namespace History {
	export const collection = 'history';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		title: string;
		description: string;
		text: string;
		images: Image.Model[];
	};

	export const modelState: Model = {
		...Common.modelState,
		title: '',
		description: '',
		text: '',
		images: [],
	};
}
